import React, { useState, createContext } from "react"

export const AudioContext = createContext()

export const AudioProvider = props => {
    const [music, setMusic] = useState( {
        id: "",
        title: "",
        src: "",
        cover: "",
        type: "",
        currentPlaying: {
            musicId: "",
            isPlaying: false
        }
    } )
    return (
        <AudioContext.Provider value={[music, setMusic]}>
            {props.children}
        </AudioContext.Provider>
    )
}